// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_DeleteticketResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tickets_DeleteticketResponseDados {
deleted: boolean
}

export type Tickets_DeleteticketResponse = ApiResponse<Tickets_DeleteticketResponseDados>;

registerResponseContract('Tickets_DeleteticketResponse', {
  deleted: { type: 'boolean', required: true },
})
